<!--
 * @Author: DY
 * @Date: 2024-12-07 11:36:00
 * @LastEditTime: 2026-04-09 15:30:40
 * @Description: 进出场登记表单【采购管理】
 * @FilePath: \ShiMo_Mobile\src\views\purchase\entryAndExitRegister\form.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="entryAndExitRegisterForm commonFormStyles">
            <HeaderNav
                header-title="进出场登记表"
                left-icon-name="2"
                right-icon-name="3"
                :extr="{ leftCallBack: swiperright }"
            ></HeaderNav>
            <ul class="formList">
                <van-field
                    disabled
                    label="汽运单编号"
                    placeholder="自动生成"
                    :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                    v-model="formData.YsdNumber"
                ></van-field>
                <van-field
                    readonly
                    label="供货单编号"
                    placeholder="选择供货单"
                    :disabled="isDisabled"
                    :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                    v-model="formData.SupplyNumber"
                    @click="selectSupplyOrder"
                ></van-field>
                <van-field
                    label="车牌号"
                    placeholder="输入车牌号"
                    :disabled="isDisabled"
                    :left-icon="require('@/assets/images/icons/icon_36@2x.png')"
                    v-model="formData.PlateNumber"
                ></van-field>
                <van-field
                    label="物流单位"
                    placeholder="输入物流单位"
                    :disabled="isDisabled"
                    :left-icon="require('@/assets/images/icons/icon_4@2x.png')"
                    v-model="formData.TransportName"
                ></van-field>
                <van-field
                    label="司机"
                    placeholder="输入司机"
                    :disabled="isDisabled"
                    :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                    v-model="formData.DriverName"
                ></van-field>
                <van-field
                    label="联系电话"
                    placeholder="输入联系电话"
                    :disabled="isDisabled"
                    :left-icon="require('@/assets/images/icons/icon_9@2x.png')"
                    v-model="formData.DriverPhone"
                ></van-field>
                <van-field
                    readonly
                    label="供应商"
                    placeholder="选择供货单"
                    :disabled="isDisabled"
                    :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                    v-model="formData.SupplierName"
                ></van-field>
                <van-field
                    readonly
                    label="采购计划编号"
                    placeholder="选择供货单"
                    :disabled="isDisabled"
                    :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                    v-model="formData.CollectNumber"
                ></van-field>
                <van-field
                    readonly
                    label="物料代码"
                    placeholder="选择供货单"
                    :disabled="isDisabled"
                    :left-icon="require('@/assets/images/icons/icon_46@2x.png')"
                    v-model="formData.MaterialList[0].MaterialCode"
                ></van-field>
                <van-field
                    readonly
                    label="需求部门"
                    placeholder="选择需求部门"
                    :disabled="isDisabled"
                    :left-icon="require('@/assets/images/icons/icon_29@2x.png')"
                    v-model="formData.MaterialList[0].AllocationList[0].ApplyDeptName"
                    @click="showDepartment = true"
                ></van-field>
                <van-field
                    readonly
                    label="物料短描述"
                    placeholder="选择供货单"
                    :disabled="isDisabled"
                    :left-icon="require('@/assets/images/icons/icon_28@2x.png')"
                    v-model="formData.MaterialList[0].MaterialShortName"
                ></van-field>
                <van-field
                    readonly
                    label="单位"
                    placeholder="选择供货单"
                    :disabled="isDisabled"
                    :left-icon="require('@/assets/images/icons/icon_21@2x.png')"
                    v-model="formData.MaterialList[0].Unit"
                ></van-field>
                <van-field
                    name="radio"
                    label="计量类别"
                    class="fieldRadio"
                    :left-icon="require('@/assets/images/icons/icon_23@2x.png')"
                >
                    <template #input>
                        <van-radio-group disabled v-model="formData.MeasureType" direction="horizontal">
                            <van-radio :name="0" checked-color="#ee0a24">
                                计件
                            </van-radio>
                            <van-radio :name="1" checked-color="#ee0a24">
                                计量
                            </van-radio>
                        </van-radio-group>
                    </template>
                </van-field>
                <van-field
                    disabled
                    label="本次供应量"
                    placeholder="选择供货单"
                    :left-icon="require('@/assets/images/icons/icon_16@2x.png')"
                    v-model="formData.MaterialList[0].SupplyCount"
                ></van-field>
                <van-field
                    name="radio"
                    label="计量方式"
                    class="fieldRadio"
                    :left-icon="require('@/assets/images/icons/icon_23@2x.png')"
                >
                    <template #input>
                        <van-radio-group disabled v-model="formData.RecordType" direction="horizontal">
                            <van-radio :name="0" checked-color="#ee0a24">
                                甲方重量为准
                            </van-radio>
                            <van-radio :name="1" checked-color="#ee0a24">
                                乙方重量为准
                            </van-radio>
                        </van-radio-group>
                    </template>
                </van-field>
                <van-field
                    label="乙方出厂净重"
                    placeholder="输入乙方出厂净重"
                    :required="formData.RecordType === 1"
                    :disabled="isDisabled || formData.RecordType === 0"
                    :left-icon="require('@/assets/images/icons/icon_6@2x.png')"
                    v-model="formData.MaterialList[0].IntoCount"
                ></van-field>
                <van-field
                    label="毛重"
                    placeholder="输入毛重"
                    :disabled="isDisabled"
                    :left-icon="require('@/assets/images/icons/icon_6@2x.png')"
                    v-model="formData.MaterialList[0].GrossWeight"
                    @change="netWeightCalculation"
                ></van-field>
                <van-field
                    label="皮重"
                    placeholder="输入皮重"
                    :disabled="isDisabled"
                    :left-icon="require('@/assets/images/icons/icon_6@2x.png')"
                    v-model="formData.MaterialList[0].TareWeight"
                    @change="netWeightCalculation"
                ></van-field>
                <van-field
                    disabled
                    label="净重"
                    placeholder="输入净重"
                    :left-icon="require('@/assets/images/icons/icon_6@2x.png')"
                    v-model="formData.MaterialList[0].NetWeight"
                ></van-field>
                <van-field
                    label="进场时间"
                    placeholder="选择进场时间"
                    :disabled="isDisabled"
                    :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                    v-model="formData.MaterialList[0].GrossTime"
                    @click="selectCalendar('GrossTime', formData.MaterialList[0].GrossTime)"
                ></van-field>
                <van-field
                    label="出场时间"
                    placeholder="选择出场时间"
                    :disabled="isDisabled"
                    :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                    v-model="formData.MaterialList[0].TareTime"
                    @click="selectCalendar('TareTime', formData.MaterialList[0].TareTime)"
                ></van-field>
                <van-field
                    label="扣重"
                    placeholder="输入扣重"
                    :disabled="isDisabled"
                    :left-icon="require('@/assets/images/icons/icon_6@2x.png')"
                    v-model="formData.MaterialList[0].DeductionWeight"
                    @change="netWeightCalculation"
                ></van-field>
                <van-field
                    disabled
                    label="签收数量"
                    :left-icon="require('@/assets/images/icons/icon_6@2x.png')"
                    v-model="formData.MaterialList[0].SignCount1"
                ></van-field>
                <van-field
                    label="登记人"
                    placeholder="输入登记人"
                    :disabled="isDisabled"
                    :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                    v-model="formData.CheckUserName1"
                ></van-field>
                <van-field
                    label="登记时间"
                    placeholder="选择登记时间"
                    :disabled="isDisabled"
                    :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                    v-model="formData.CheckTime1"
                    @click="selectCalendar('CheckTime1', formData.CheckTime1)"
                ></van-field>
                <van-field
                    label="外观检测意见"
                    type="textarea"
                    :rows="2"
                    :disabled="isDisabled"
                    :left-icon="require('@/assets/images/icons/icon_10@2x.png')"
                    v-model="formData.MaterialList[0].AppearanceDetection"
                ></van-field>
            </ul>
            <footer class="currencyFooterStyle">
                <template v-if="!isDisabled">
                    <button class="confirm" @click="submitForm">
                        提交
                    </button>
                    <button class="confirm" @click="saveForm">
                        保存
                    </button>
                </template>
                <button class="confirm" @click="closeAllocationForm">
                    关闭
                </button>
            </footer>
            <van-popup v-model="showCalendar" position="bottom" :style="{ height: '50%' }">
                <van-datetime-picker
                    v-model="defaultDate"
                    type="datetime"
                    @confirm="onConfirmCalendar"
                    @cancel="showCalendar = false"
                ></van-datetime-picker>
            </van-popup>
            <van-action-sheet
                v-model="showDepartment"
                cancel-text="取消"
                description="选择需求部门"
                close-on-click-action
                :actions="demandDepartmentOptions"
                @select="selectConfirm"
            ></van-action-sheet>
        </div>
    </v-touch>
</template>

<script>
import currencyFun from '@/assets/js/currencyFun/index.js';
import { HeaderNav } from '@/components/';
import NP, { minus } from 'number-precision';
NP.enableBoundaryChecking(false);
export default {
    // 库位表单
    name: 'entry-and-exit-register-form',
    beforeRouteLeave(to, from, next) {
        if (to.path === '/entryAndExitRegister') {
            this.$store.commit('noKeepAlive', 'entry-and-exit-register-form');
        }
        next();
    },
    components: {
        HeaderNav,
    },
    props: {},
    data() {
        return {
            isDisabled: false,
            showCalendar: false,
            calendarType: '',
            defaultDate: [],
            minDate: new Date(2000, 0, 1),
            demandDepartmentOptions: [],
            showDepartment: false,
            formData: {
                Id: '',
                YsdNumber: '',
                SupplyNumber: '',
                ContractNumber: '',
                ContractNo: '',
                PlateNumber: '',
                TransportName: '',
                DriverName: '',
                DriverPhone: '',
                SupplierId: '',
                SupplierName: '',
                CollectNumber: '',
                MeasureType: 1,
                IntoTime: '',
                CheckUserId1: '',
                CheckUserName1: '',
                CheckTime1: '',
                SignUserId1: '',
                SignUserName1: '',
                SignTime1: '',
                Remarks: '',
                RecordType: null,
                MaterialList: [{
                    Id: '',
                    YsdId: '',
                    Category: 0,
                    MaterialCode: '',
                    MaterialName: '',
                    MaterialShortName: '',
                    MaterialType: '',
                    Unit: '',
                    SupplyCount: 0,
                    IntoCount: null,
                    SignCount1: 0,
                    AppearanceDetection: '',
                    GrossWeight: 0,
                    TareWeight: 0,
                    NetWeight: 0,
                    DeductionWeight: 0,
                    GrossTime: '',
                    TareTime: '',
                    Remarks: '',
                    SortNum: 0,
                    AllocationList: [{
                        Id: '',
                        YsdmId: '',
                        ApplyDeptId: '',
                        ApplyDeptName: '',
                        ApplyCount: 0,
                        SupplyedCount: 0,
                        SupplyCount: 0,
                        Remarks: '',
                        SortNum: 0,
                    }],
                }],
            },
            openType: '',
        };
    },
    computed: {},
    watch: {},
    activated() {
        if (this.$route.params.SupplyOrder) {
            this.formData.SupplyNumber = this.$route.params.SupplyOrder[0].supply_number;
            this.formData.ContractNumber = this.$route.params.SupplyOrder[0].contract_number;
            this.formData.ContractNo = this.$route.params.SupplyOrder[0].contract_no;
            this.formData.SupplierName = this.$route.params.SupplyOrder[0].supplier_name;
            this.formData.SupplierId = this.$route.params.SupplyOrder[0].supplier_id;
            this.formData.CollectNumber = this.$route.params.SupplyOrder[0].collect_number;
            this.formData.RecordType = this.$route.params.SupplyOrder[0].record_type;
            this.formData.MaterialList[0].MaterialCode = this.$route.params.SupplyOrder[0].material_code;
            this.formData.MaterialList[0].MaterialShortName = this.$route.params.SupplyOrder[0].material_short_name;
            this.formData.MaterialList[0].Unit = this.$route.params.SupplyOrder[0].unit;
            this.formData.MaterialList[0].SupplyCount = this.$route.params.SupplyOrder[0].supply_count;
            this.formData.MaterialList[0].material_category = this.$route.params.SupplyOrder[0].material_category;
            if ((this.$route.params.SupplyOrder[0].apply_dept_ids || '') !== '') {
                const labels = this.$route.params.SupplyOrder[0].apply_dept_names.split(',');
                const values = this.$route.params.SupplyOrder[0].apply_dept_ids.split(',');
                this.demandDepartmentOptions = labels.map((item, index) => {
                    return {
                        name: item,
                        value: values[index],
                    };
                });
                if (labels.length === 1) {
                    this.formData.MaterialList[0].AllocationList[0].ApplyDeptName = labels[0];
                    this.formData.MaterialList[0].AllocationList[0].ApplyDeptId = values[0];
                }
            }
        }
    },
    created() {
        this.initpage();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },

        async initpage() {
            this.openType = this.$route.params.type;
            if (this.openType === 'add') {
                this.formData.CheckUserName1 = this.$takeTokenParameters('Name');
                this.formData.CheckUserId1 = this.$takeTokenParameters('Uid');
                this.formData.CheckTime1 = currencyFun.timeFormat(new Date(), 'yyyy-MM-dd');
            }
            if (this.openType === 'edit' || this.openType === 'see') {
                this.formData = await this.getCheckSignForReceipt(this.$route.params.data.id);
                if (!this.formData.MaterialList) {
                    this.formData.MaterialList = [{
                        Id: '',
                        YsdId: '',
                        Category: 0,
                        MaterialCode: '',
                        MaterialName: '',
                        MaterialShortName: '',
                        MaterialType: '',
                        Unit: '',
                        SupplyCount: 0,
                        IntoCount: null,
                        SignCount1: 0,
                        AppearanceDetection: '',
                        GrossWeight: 0,
                        TareWeight: 0,
                        NetWeight: 0,
                        DeductionWeight: 0,
                        GrossTime: '',
                        TareTime: '',
                        Remarks: '',
                        SortNum: 0,
                        AllocationList: [{
                            Id: '',
                            YsdmId: '',
                            ApplyDeptId: '',
                            ApplyDeptName: '',
                            ApplyCount: 0,
                            SupplyedCount: 0,
                            SupplyCount: 0,
                            Remarks: '',
                            SortNum: 0,
                        }],
                    }];
                }
            }
            if (this.openType === 'see') {
                this.isDisabled = true;
            }
        },

        selectSupplyOrder() {
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectListView',
                params: {
                    pageTitle: '选择供货单',
                    sourcePath: 'entryAndExitRegisterForm',
                    listCode: 'plan_supply_select',
                    callbackDataKey: 'SupplyOrder',
                    relationKey: 'uid',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    pageIndex: 0,
                    headerList: [{
                        name: '供货单号',
                        code: 'supply_number',
                        isTitle: true,
                    }, {
                        name: '供应商',
                        code: 'supplier_name',
                        icon: 'icon_4@2x',
                    }, {
                        name: '供货日期',
                        code: 'supply_date',
                        icon: 'icon_7@2x',
                    }, {
                        name: '物料',
                        code: 'category_name',
                        icon: 'icon_46@2x',
                    }, {
                        name: '短描述',
                        code: 'material_short_name',
                        icon: 'icon_10@2x',
                    }, {
                        name: '需求部门',
                        code: 'apply_dept_names',
                        icon: 'icon_29@2x',
                    }, {
                        name: '供货单数量',
                        code: 'supply_count',
                        icon: 'icon_6@2x',
                    }, {
                        name: '采购计划数量',
                        code: 'suggest_count',
                        icon: 'icon_6@2x',
                    }, {
                        name: '联系人',
                        code: 'contacts',
                        icon: 'icon_8@2x',
                    }, {
                        name: '联系电话',
                        code: 'contacts_phone',
                        icon: 'icon_9@2x',
                    }],
                },
            });
        },

        selectConfirm(data) {
            const res = this.demandDepartmentOptions.filter(item => item.value === data.value)[0];
            this.formData.MaterialList[0].AllocationList[0].ApplyDeptName = res.name;
            this.formData.MaterialList[0].AllocationList[0].ApplyDeptId = data.value;
        },

        selectCalendar(type, date) {
            if (this.isDisabled) {return;}
            if ((date || '') !== '') {
                date = currencyFun.timeFormat(new Date(date), 'yyyy-MM-dd HH:mm:ss');
                this.defaultDate = new Date(date);
            } else {
                this.defaultDate = new Date();
            }
            this.calendarType = type;
            this.showCalendar = true;
        },
        onConfirmCalendar(val) {
            if (this.calendarType === 'CheckTime1') {
                this.formData[this.calendarType] = currencyFun.timeFormat(new Date(val), 'yyyy-MM-dd HH:mm:ss');
            } else {
                this.formData.MaterialList[0][this.calendarType] = currencyFun.timeFormat(new Date(val), 'yyyy-MM-dd HH:mm:ss');
            }
            this.showCalendar = false;
        },

        netWeightCalculation() {
            this.formData.MaterialList[0].NetWeight = NP.minus(this.formData.MaterialList[0].GrossWeight || 0, this.formData.MaterialList[0].TareWeight || 0);
            this.formData.MaterialList[0].SignCount1 = NP.minus(this.formData.MaterialList[0].GrossWeight || 0, this.formData.MaterialList[0].TareWeight || 0, this.formData.MaterialList[0].DeductionWeight || 0);
            if (this.formData.RecordType === 0) {
                this.formData.MaterialList[0].IntoCount = this.formData.MaterialList[0].SignCount1;
            }
        },

        async saveForm() {
            if (this.formData.RecordType === 1 && (!this.formData.MaterialList[0].IntoCount || Number(this.formData.MaterialList[0].IntoCount) <= 0)) {
                this.$toast.fail('请填写乙方出厂净重！');
                return;
            }
            if (this.formData.RecordType === 0) {
                this.formData.MaterialList[0].IntoCount = this.formData.MaterialList[0].SignCount1;
            }

            let res = null;
            if (this.openType === 'edit') {
                res = await this.editSaveApplyData(this.formData);
            } else {
                res = await this.addSaveApplyData(this.formData);
            }
            if (res) {
                this.formData = res;
                this.$toast.success('保存成功。');
            }
        },

        async submitForm() {
            if (this.formData.Id === '') {
                this.$toast.fail('请先保存表单！');
                return;
            }
            const res = await this.submitApplyData(this.formData.Id);
            if (res) {
                this.$toast.success('提交成功。');
                this.closeAllocationForm();
            }
        },

        closeAllocationForm() {
            this.$router.isBack = 1;
            this.$router.replace({
                name: 'entryAndExitRegister',
                params: {
                    saveCallback: true,
                },
            });
        },

        getCheckSignForReceipt(id) {
            return this.$axios.$get(`/interfaceApi/procurement/ysd/info/${id}`, { defEx: true });
        },
        addSaveApplyData(requestData) {
            return this.$axios.$post('/interfaceApi/procurement/ysd/create', requestData, { defEx: true });
        },
        editSaveApplyData(requestData) {
            return this.$axios.$post('/interfaceApi/procurement/ysd/modify', requestData, { defEx: true });
        },
        submitApplyData(id) {
            return this.$axios.$get(`/interfaceApi/procurement/ysd/check/${id}`, { defEx: true });
        },
    },
};
</script>
<style lang="stylus"></style>
